module.exports = __webpack_public_path__ + "img/_DSC4925.jpg";